export default __webpack_public_path__ + "static/media/pixar image.e5eba577.webp";